import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastMessageService } from '../../toast-message/toast-message.service';
import { DeleteRecordDialogComponent } from '../delete-record-dialog/delete-record-dialog.component';
import { AuthService } from 'src/app/services/auth.service';
import { FormService } from 'src/app/services/form.service';
import { RecordListSort } from 'src/app/interfaces/record-list.interface';


@Component({
  selector: 'app-basic-record-list',
  templateUrl: './basic-record-list.component.html',
  styleUrls: ['./basic-record-list.component.scss']
})
export class BasicRecordListComponent implements OnInit {

  // api endpoint
  @Input() endpoint: string;
  @Input() baseRoute: string;
  @Input() subject: any;

  @Input() showDelete: boolean = true;

  @Input() claimProgram: string;
  @Input() codeKey = 'Code';
  @Input() descriptionKey = 'Description';
  @Input() readOnlyCodeValues: string[] = [];

  // records states
  init: boolean = true;
  loading: boolean = true;
  records: any[];

  // record list params
  searchFields: string[] = [];
  sortFields: RecordListSort[];

  refresh: any;

  // delete
  deleteIds: number[] = [];

  // claims
  canDelete: boolean = true;
  canAdd: boolean = true;
  canEdit: boolean = true;

  constructor(
    private _authSvc: AuthService,
    private _apiSvc: ApiService,
    private _formSvc: FormService,
    public dialog: MatDialog,
    private _toastMsgSvc: ToastMessageService
  ) { }

  /**
   * Component Init
   */
  ngOnInit() {

    if (this.claimProgram) {
      this.canAdd = this._authSvc.hasClaim(this.claimProgram, 'Add');
      this.canEdit = this._authSvc.hasClaim(this.claimProgram, 'Edit');
      this.canDelete = this._authSvc.hasClaim(this.claimProgram, 'Delete');
    }

    this.searchFields.push(this.codeKey);
    this.searchFields.push(this.descriptionKey);

    this.sortFields = [{
      label: 'Code',
      value: this.codeKey,
      default: true
    }, {
      label: 'Description',
      value: this.descriptionKey
    }, {
      label: 'Discontinued Date',
      value: 'EndDate'
    }, {
      label: 'Effective Date',
      value: 'StartDate'
    }];
  
  }

  /**
   *  Prepare data for the view
   */
  onRecordsUpdated(res: any): void {

    // send the data to the view
    this.records = res.Data;

    if (res.Data && res.Data.length > 0) {
      this.init = false;
    }

  }

  /**
   * Tell child record list component to update records
   */
  refreshRecords(): void {
    this.refresh = new Date().getTime();
  }

  /**
   * Remove id from delete ids array
   * @param id
   */
  private _removeDeleteId(id: number): void {
    const index = this.deleteIds.indexOf(id);
    this.deleteIds.splice(index, 1);
  }

  /**
   * Perform style deletion
   * @param {number} id - record id
   */
  private _performRecordDeletion(id: number): void {

    this.deleteIds.push(id);

    this._apiSvc.delete(`${this.endpoint}/${id}`)
      .subscribe(() => {
        this._toastMsgSvc.send({
          message: this.subject[0] ? `${this.subject[0]} deleted` : 'Record deleted',
          icon: 'check_circle_outline',
          type: 'success'
        });
        this.refreshRecords();
        this._removeDeleteId(id);
      }, (err: any) => {

        const errors = this._formSvc.processFormErrors(err);

        if (errors.formErrors) {

          this._removeDeleteId(id);

          this._toastMsgSvc.send({
            message: errors.formErrors[0].Message,
            icon: 'error_outline',
            type: 'error',
            duration: 10000
          });
        }

      });

  }

  isReadOnly(codeKey: string): boolean {
    if (codeKey) {
      if (this.readOnlyCodeValues.includes(codeKey)) {
         return true;
      }
    }
    return false;
  }

  /**
   * Delete selection
   * @param {number} catId
   */
  deleteRecord(id: number): void {

    // open the dialog
    const dialogRef = this.dialog.open(DeleteRecordDialogComponent, {
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      position: {top: '60px'},
      width: '400px',
      data: {
        subject: this.subject[0] || 'record',
        id
      }
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res.confirm) {
        this._performRecordDeletion(res.id);
      }
    });

  }

}
